import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { RequestNextApi } from "../../../../api/Request";
import { getCookie } from "../../../../utils/cookieHandle";
import { ShowNotification } from "../../../../utils/notification/snackbarUtils";
import DeleteIcon from "@mui/icons-material/Delete";
import { useRouter } from "next/router";
import dayjs from "dayjs";

function InvoiceAgingReport({
  isFromReports = true,
  invoiceIds: _invoiceIds = [],
  date: _date = dayjs().format("YYYY-MM-DD"),
  view 
}) {
  console.log("view: ", view)
  const [invoiceId, setInvoiceId] = React.useState("");
  const [invoiceList, setInvoiceList] = React.useState(_invoiceIds ?? []);
  const invoiceListRef = React.useRef(_invoiceIds ?? []);
  const [date, setDate] = React.useState(_date ?? "");
  const [invoices, setInvoices] = React.useState([]);

  const [loading, setLoading] = React.useState(false);
  const router = useRouter();

  React.useEffect(() => {
    if (!isFromReports) {
      onRunReport();
    }
  }, [isFromReports]);


  const downloadFile = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  const openInNewTab = (blob) => {
    const url = URL.createObjectURL(blob);
    const newTab = window.open(url, "_blank");
    if (newTab) {
      newTab.onload = () => URL.revokeObjectURL(url);
    } else {
      console.error("Failed to open new tab");
    }
  };

  const onRunReport = async () => {
    if (invoiceId.trim()) {
      handleAddInvoice()
    }
    if (isFromReports) {
      router.push(
        {
          pathname: "/staff/invoice-aging-report",
          query: {
            invoiceIds: invoiceListRef.current.join(","),
            date: date
          },
        },
        "/staff/invoice-aging-report"
      );
      return;
    }
    try {
      setLoading(true);
      const result = await RequestNextApi.post(
        "/admin/report/run-invoice-aging-report",
        {
          jwtToken: getCookie("jwt-token"),
          ...(invoiceListRef.current.length && { invoice_ids: invoiceListRef.current }),
          date: `${date} 23:59:59`,
        }
      );
      if (result.data.success) {
        setInvoices(result.data.report);
      } else {
        ShowNotification.error(result.data.message);
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };
  const handleRemoveInvoice = (index) => {
    setInvoiceList(invoiceList.filter((_, i) => i !== index));
    invoiceListRef.current = invoiceListRef.current.filter(
      (_, i) => i !== index
    );
  };

  const handleAddInvoice = () => {
    if (invoiceId.trim()) {
      setInvoiceList([...invoiceList, invoiceId.trim()]);
      invoiceListRef.current = [...invoiceListRef.current, invoiceId.trim()];
    }
    setInvoiceId("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleAddInvoice();
      event.preventDefault(); // Prevent form submission or other default behaviors
    }
  };




  const onRunReport2 = async (type) => {
    try {
      setLoading(true);
      const result = await RequestNextApi.post(
        "/admin/report/run-invoice-aging-report",
        {
          jwtToken: getCookie("jwt-token"),
          date: `${date}`,
          export_type: type,
        },
        {
          ...(type == "pdf" && { responseType: "blob" }),
        }
      );
      if (
        ((type === "html") &&
          result.data &&
          typeof result.data === "string") ||
        (type === "json" && result.data.success) || (type === "pdf" && result.data)
      ) {

        if (type === "html") {
          const blob = new Blob([result.data], { type: "text/html" });
          openInNewTab(blob);
        }
        if (type === "pdf") {
          const blob = new Blob([result.data], { type: "application/pdf" });
          openInNewTab(blob);
        }
      } else {
        ShowNotification.error(result?.data?.message);
      }
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className={`${isFromReports ? "border-[1px] border-solid border-primary-100 rounded-xl p-[20px]" : ""}`}>
      {isFromReports && (
        <Typography variant="h4" className={`${!isFromReports ? "mt-3" : ""} font-normal`}>
          Invoice Aging Report
        </Typography>
      )}

      <Box
        display="flex"
        flexWrap="wrap"
        gap={1}
        className={`${invoiceList.length ? "mt-4" : ""}`}
      >
        {invoiceList.map((id, index) => (
          <Box
            key={index}
            display="flex"
            alignItems="center"
            padding="4px 8px"
            border="1px solid #ccc"
            borderRadius="8px"
          >
            <ListItemText primary={id} />
            <IconButton size="small" onClick={() => handleRemoveInvoice(index)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Box>
      <div
        className={`flex gap-2 ${invoiceList.length ? "mt-6" : "mt-4"
          } items-center`}
      >
        <TextField
          label="Invoice ID (optional)"
          color="secondary"
          fullWidth
          size="small"
          className="flex flex-1"
          value={invoiceId}
          onChange={(e) => {
            setInvoiceId(e.target.value);
          }}
          onKeyDown={handleKeyDown}
        />
        <TextField
          label="Date"
          color="secondary"
          focused
          size="small"
          type="date"
          value={date}
          onChange={(e) => {
            setDate(e.target.value);
          }}
        />
        {view =="staff"?
           
           <></>
           :
                <Button
                variant="contained"
                className="bg-secondary-500 hover:bg-secondary-500 w-[100px]"
                onClick={() => {
                  onRunReport();
                }}
                type="button"
                disabled={loading}
              >
                Run
              </Button>
           
      
        }

        <Button
          variant="contained"
          className="bg-secondary-500 hover:bg-secondary-500 w-[100px]"
          onClick={() => {
            onRunReport2("html");
          }}
          type="button"
          disabled={loading}
        >
          View
        </Button>
        <Button
          variant="contained"
          className="bg-secondary-500 hover:bg-secondary-500 w-[100px]"
          onClick={() => {
            onRunReport2("pdf");
          }}
          type="button"
          disabled={loading}
        >
          PDF
        </Button>
      </div>
      {
        !isFromReports &&
        (loading ? (
          <div className="mt-6 flex flex-1 items-center justify-center">
            <CircularProgress color="secondary" size={20} />
          </div>
        ) : (
          <div className="mb-[100px]">
            <TableContainer component={Paper} style={{ marginTop: "20px" }}>
              <Table aria-label="invoice aging report">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>Invoice ID</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Name</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Total Amount</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Open Balance</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Current</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Past Due 0-30</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Past Due 31-60</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Past Due 61-90</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Past Due 90+</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!invoices.length && (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        No data found
                      </TableCell>
                    </TableRow>
                  )}
                  {invoices.map((invoice) => (
                    <TableRow key={invoice.invoice_id}>
                      <TableCell>{invoice.invoice_id}</TableCell>
                      <TableCell>{invoice.customer_name}</TableCell>
                      <TableCell>
                        ${invoice.total_invoice_amount.toFixed(2)}
                      </TableCell>
                      <TableCell>${invoice.open_balance.toFixed(2)}</TableCell>
                      <TableCell>
                        ${invoice.invoice_aging.current.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        ${invoice.invoice_aging.past_due_0_30.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        ${invoice.invoice_aging.past_due_31_60.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        ${invoice.invoice_aging.past_due_61_90.toFixed(2)}
                      </TableCell>
                      <TableCell>
                        ${invoice.invoice_aging.past_due_90_plus.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ))
      }
    </div >
  );
}

export default InvoiceAgingReport;
